import { call, put } from "redux-saga/effects"
import { jwtDecode } from "jwt-decode"
import * as Cookies from "es-cookie"
import { refreshToken } from "apis/JWToken"

import { storeIsAuthLoading, storeIsAuthentication } from "actions"

// PDにリダイレクトしたりF5更新した場合に実行される
export function* execDAuthInitial() {
  try {
    const jwt = Cookies.get("JWToken")
    const { tokenRefreshError } = yield call(getToken, jwt)

    if (tokenRefreshError) {
      throw tokenRefreshError
    }
  } catch (e) {
    Cookies.remove("JWToken")
  } finally {
    yield put(storeIsAuthLoading(false))
  }
}

// アクセストークン有効期限を確認する
export function* getToken(jwt) {
  try {
    const { expireAt } = jwtDecode(jwt)
    const limitTime = new Date()
    limitTime.setSeconds(limitTime.getSeconds() + 10)
    // アクセストークン有効期限切れ（Expireの時間+10秒）の場合、トークンリフレッシュを行う
    if (expireAt < limitTime) {
      const { payload, error } = yield call(refreshToken, jwt)
      if (payload && !error) {
        // Authenticated!!
        Cookies.set("JWToken", payload.token, { secure: true })
        const authentication = {
          isAuthentication: true,
          isAuthenticationError: false,
          jwt: payload.token,
        }
        yield put(storeIsAuthentication(authentication))
        return {
          jwt: payload.token,
        }
      }
      // トークンリフレッシュ失敗、またはdアカ側でエラー発生の場合
      throw Error(error.status === 401 ? "invalid token" : "dauth error")
    }
    // アクセストークン有効期限内の場合、リフレッシュの必要性なし
    const authentication = {
      isAuthentication: true,
      isAuthenticationError: false,
      jwt,
    }
    yield put(storeIsAuthentication(authentication))
    return {
      jwt,
    }
  } catch (e) {
    // URL実行時にクッキーにJWTがない場合
    // トークンリフレッシュ失敗、またはdアカ側でエラー発生の場合
    Cookies.remove("JWToken")
    const authentication = {
      isAuthentication: false,
      isAuthenticationError: e.message === "dauth error",
      jwt: null,
    }
    yield put(storeIsAuthentication(authentication))
    return {
      tokenRefreshError: e,
      jwt: null,
    }
  }
}
